import Api from './Api'

const endpoint = 'states'

export default class StateService extends Api{

    async all (filter, regionId) {
        const response = await this.client.get(`${endpoint}/all`,{
            params: {
                field: 'name',
                value: filter,
                parent_field: 'region_id',
                parent_value: regionId
            }
        });
        if (response.data) {
            return response.data.map(s => {
                return {
                    value: s.id,
                    text: s.name,
                    region_id: s.region_id
                }
            })
        }
        throw new Error('No data')
    }
}
